import { Component, OnInit } from '@angular/core';
import { Cloudinary } from 'services/cloudinary';
import { CmsAddonPlans } from 'store/cms/models';
import { Subscription } from 'rxjs';
import { XmStore, XmStoreUtil } from 'core/services';
import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';
import { ProgressStatus } from 'my-account/constants';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'xm-addon-failure',
    templateUrl: './addon-failure.html',
    styleUrls: ['./addon-failure.scss'],
    standalone: false
})
export class XmAddOnFailure implements OnInit {
    public failureIcon: MediaImageOptions;
    public planData: CmsAddonsFailureContent;
    public header: string;
    public planDataContent: CmsAddonDialog;

    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;
    private addonsUtil: AddonsUtil;
    private addonType: string;
    private state: StateService;

    constructor(xmStore: XmStore, addonsUtil: AddonsUtil, state: StateService) {
        Object.assign(this, { xmStore, addonsUtil, state });
    }
    public ngOnInit(): void {
        this.addonsUtil.completeAddonsPolling(ProgressStatus.FAIL);
        this.addonType = this.addonsUtil.addonType;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsAddonPlans>(CmsAddonPlans), (result: CmsAddonPlans) => {
            this.planDataContent = result.plans.find((plan: CmsAddonPlan) => plan.gtp1B && plan.type === this.addonType).content;
            this.header = this.planDataContent.summaryData.header;
            this.planData = this.planDataContent.failureData;
        }));

        this.failureIcon = {
            mobile: Cloudinary.generateMediaFromCms(this.planData.failureIcon)
        };  
    }

    public goBack(): void {
        this.state.go('account.activity.landing');
    }
}
